// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export class Variant {
    constructor(
        public name: string,
        public configuration: unknown
    ) {}
}
